import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import SearchBox from "./SearchBox";
import Table from "./Table";

import { dateToDateFormat } from "util";

import auditTrailContext from "util/context/auditTrail";

const Main = () => {
    // const [dateRange, setDateRange] = useState([new Date().setMonth(new Date().getMonth() - 1), new Date().getTime()]);
    // const [ search, setSearch ] = useState({method: null, user: null, auth: null})
    const tblRef = useRef(null);
    const apiCall = useCallback((body) => {
        tblRef.current.getData(body)
    },[])
    const context = useMemo(() => ({ apiCall }), [apiCall]);

    return (
        <auditTrailContext.Provider value={context}>
            <SearchBox />
            <Table ref={tblRef} />
        </auditTrailContext.Provider>
    );
};

export default Main;
